import Filters from "byzantine/src/filters";
import type { PaginatedDualApproval } from "byzantine/src/dbbl/businessLogic/entities/dualApprovals/types";

export const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const getFormattedAmount = (
  item: PaginatedDualApproval,
  achPaymentsCollectFeature?: boolean
) => {
  if (item.bulkPaymentId || item.bulkReversalId) {
    return achPaymentsCollectFeature
      ? item.bulk?.netTotalDollarsWithSign || "$0"
      : item.bulk?.netTotalDollarsWithoutSign || "$0";
  }
  const formattedAmount = Filters.currency(item.dollarAmount, {
    hasDecimal: true,
  });

  return `${achPaymentsCollectFeature ? "-" : ""}${formattedAmount}`;
};

export const getNameDescription = (item: PaginatedDualApproval): string => {
  const formattedAmount = Filters.currency(item.dollarAmount, {
    hasDecimal: true,
  });

  if (item.bulkPaymentTemplateVersionId) {
    return item.templateVersion?.templateName || "";
  }
  if (item.bulkPaymentId) {
    return item.bulk?.title || "";
  }
  if (item.internationalWireId || item.wireId) {
    return `Sending ${formattedAmount}`;
  }
  if (item.bulkReversalId || item.achReversalId) {
    return `Reversing ${formattedAmount}`;
  }
  if (item.achId || item.scheduledACHId) {
    const direction =
      item.transactionType === "debit" ? "Collecting" : "Sending";
    return `${direction} ${formattedAmount}`;
  }
  if (item.wireImportBatchId) {
    return item.wireImport?.description || "";
  }
  return "";
};
